import { Component, inject, TemplateRef, contentChild } from '@angular/core';
import { AuthService } from '@modules/auth/services/auth.service';
import { openCloseAnimation } from '@shared/animations';
import { AvatarUsuarioComponent } from '@shared/components/avatar-usuario/avatar-usuario.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { UsuarioLogadoInfoComponent } from '@shared/components/usuario-logado-info/usuario-logado-info.component';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';
import { DropdownComponent } from '@shared/ui/dropdown/dropdown.component';
import { ModalTrocarSenhaService } from '../../services/modal-trocar-senha.service';
import { Router } from '@angular/router';
import { VersaoService } from '@core/versao/versao.service';

@Component({
  selector: 'app-usuario-logado-navbar',
  templateUrl: './usuario-logado-navbar.component.html',
  styleUrls: ['./usuario-logado-navbar.component.scss'],
  imports: [
    UsuarioLogadoInfoComponent,
    DropdownComponent,
    AvatarUsuarioComponent,
    IconComponent,
    AppButtonDirective,
  ],
  animations: [openCloseAnimation()],
})
export class UsuarioLogadoNavbarComponent {
  public isOpen = false;
  public readonly bodyTemplate = contentChild.required<TemplateRef<any>>('body');
  private readonly _authService = inject(AuthService);
  public readonly modalTrocarSenhaService = inject(ModalTrocarSenhaService);
  public readonly router = inject(Router);
  private readonly _versaoService = inject(VersaoService);

  verNovidades() {
    this._versaoService.abrir();
  }

  deslogar() {
    this._authService.deslogar();
  }

  toggleModalTrocarSenha() {
    this.modalTrocarSenhaService.toggleModal();
  }

  abrirMeuPerfil() {
    this.router.navigate(['/meu-perfil']);
  }
}
